import React, {useState} from "react";
import {FaChevronDown, FaLock, FaPhone} from "react-icons/fa";
import {t} from "i18next";
import {AccountContactData} from "../../models/accountContactData";
import ViewLocked from "../components/ViewLocked";

interface ContactDataViewProps {
    contactData: AccountContactData | null;
}

function ContactDataView({contactData}: ContactDataViewProps) {
    const [open, setOpen] = useState(false);

    // 🔒 Keine Daten freigegeben
    if (!contactData) {
        return (
            <ViewLocked message={t("common.messages.noSharedData")}/>
        );
    }

    return (
        <div className="view-container">
            {/* Header */}
            <div className="view-header" onClick={() => setOpen(!open)}>
                <div className="view-header-spacer"/>
                <h3 className="view-title">{t("menu.contact")}</h3>
                <FaChevronDown className={`view-arrow ${open ? "open" : ""}`}/>
            </div>

            {/* Inhalt */}
            {open && (
                <div className="view-content">

                    <div className="view-field">
                        <span className="label">{`${t("contact.fields.street")} & ${t("contact.fields.number")}`}</span>
                        <span className="value">{contactData.street} {contactData.number}</span>
                    </div>

                    <div className="view-field">
                        <span className="label">{`${t("contact.fields.zip")} & ${t("contact.fields.city")}`}</span>
                        <span className="value">{contactData.zip} {contactData.city}</span>
                    </div>

                    <div className="view-field">
                        <span className="label">{t("contact.fields.country")}</span>
                        <span className="value">{contactData.country}</span>
                    </div>

                    <div className="view-field">
                        <span className="label">{t("contact.fields.phone")}</span>

                        <div className="view-phone-list">
                            {contactData.phoneNumbers.length > 0 ? (
                                contactData.phoneNumbers.map((p) => (
                                    <div key={p.id} className="view-phone-row">
                                        <span className="value">
                                            {p.countryCode} {p.phoneNumber}
                                        </span>
                                        <a
                                            href={`tel:${p.countryCode}${p.phoneNumber}`}
                                            className="view-call-button"
                                            title={t("contact.fields.call")}
                                        >
                                            <FaPhone className="view-call-icon"/>
                                        </a>
                                    </div>
                                ))
                            ) : (
                                <span className="value">–</span>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ContactDataView;